import React from 'react'
import { captureException } from '../telemetry'

interface ErrorBoundaryState {
    hasError: boolean
    error: Error | null
}

class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>, ErrorBoundaryState> {
    state: ErrorBoundaryState = { hasError: false, error: null }

    static getDerivedStateFromError(error: Error) {
        return { hasError: true, error }
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        if (import.meta.env.DEV) console.error('ErrorBoundary caught an error:', error, errorInfo)
        captureException(error, {
            kind: 'react',
            componentStack: errorInfo.componentStack || undefined,
        })
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex items-center justify-center min-h-screen bg-surface">
                    <div className="text-center p-8 max-w-md">
                        <h1 className="text-xl font-semibold text-content mb-2">Something went wrong</h1>
                        <p className="text-content-secondary mb-4">An unexpected error occurred. Please refresh the page.</p>
                        <button
                            onClick={() => window.location.reload()}
                            className="px-4 py-2 bg-btn-primary text-btn-primary-text rounded hover:bg-btn-primary-hover"
                        >
                            Refresh
                        </button>
                    </div>
                </div>
            )
        }
        return this.props.children
    }
}

export default ErrorBoundary
